import { useSelector } from 'react-redux';
import { DIALOGS } from 'src/models/DialogModel';
import { Store, useAppDispatch } from 'src/redux/Store';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ColorPicker, useColor } from 'react-color-palette';
// eslint-disable-next-line import/no-unresolved
import 'react-color-palette/css';
import { closeDialog } from 'src/redux/actions/dialogActions';

const ColorPickerDialog = () => {
  const dispatch = useAppDispatch();
  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.colorPicker]) {
        return state.dialog[DIALOGS.colorPicker];
      }
      return { opened: false, payload: null };
    });

  const getColor = () => {
    if (payload && payload.color) {
      return payload.color;
    }
    return '#EEFFEE';
  };

  const [color, setColor] = useColor(getColor());

  const handleClose = () => {
    dispatch(closeDialog({ dialog: DIALOGS.colorPicker }));
  };

  const handleSave = () => {
    if (payload.onChange) {
      payload.onChange(color);
    }
    dispatch(closeDialog({ dialog: DIALOGS.colorPicker }));
  };

  return (
    <Dialog
      aria-labelledby="choose-a-color"
      open={opened}>
      <DialogTitle id="choose-a-color">Choose a color</DialogTitle>
      <DialogContent dividers>
        <ColorPicker color={color} onChange={setColor} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          close
        </Button>
        <Button onClick={handleSave} color="primary">
          choose
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPickerDialog;
